module.exports = __webpack_public_path__ + "./images/818055ccc158f58c8336da71d0dadd41.webp";